import React, { useContext } from "react";
import "./productStyles.css";
import DropzoneSimple from "../DropzoneSimple";
import DropzoneSVG from "../DropzoneSVG";
import background from "../assets/pfsbi.png";
import DROPZONE_DATA from "../DROPZONE_DATA";
import OpacityContext from "../OpacityContext";
import "./productStyles.css"; //* migrate styles added by js for the products to this stylesheet

export default function P_fsbi({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  const { pfdFile } = useContext(OpacityContext);

  return (
    <div className="portraitProductContainer">
      <img
        alt=""
        className="backgroundImageContainer portrait"
        src={background}
      ></img>
      {/* <div className="pFullScreen" style={pFullScreen}> */}
      <div className="portraitFullScreen">
        <DropzoneSimple
          acceptedFileTypeString={DROPZONE_DATA.data.imageAndVideo}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="portrait"
          assetFileToChange={pfdFile}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
      <div className="pFSBISVG">
        <DropzoneSVG
          acceptedFileTypeString={DROPZONE_DATA.data.svgOnly}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="svg"
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
    </div>
  );
}
